var React = require('react');

function Disc (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.5 22.0254C18.0228 22.0254 22.5 17.5482 22.5 12.0254C22.5 6.50254 18.0228 2.02539 12.5 2.02539C6.97715 2.02539 2.5 6.50254 2.5 12.0254C2.5 17.5482 6.97715 22.0254 12.5 22.0254Z","stroke":"#2A2637","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M12.5 15.0254C14.1569 15.0254 15.5 13.6822 15.5 12.0254C15.5 10.3685 14.1569 9.02539 12.5 9.02539C10.8431 9.02539 9.5 10.3685 9.5 12.0254C9.5 13.6822 10.8431 15.0254 12.5 15.0254Z","stroke":"#2A2637","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Disc.defaultProps = {"width":"27","height":"27","viewBox":"0 0 25 25","fill":"none"};

module.exports = Disc;

Disc.default = Disc;
